import { render, staticRenderFns } from "./GlassesTintsSelect.vue?vue&type=template&id=36d7bb1a&scoped=true&"
import script from "./GlassesTintsSelect.vue?vue&type=script&lang=js&"
export * from "./GlassesTintsSelect.vue?vue&type=script&lang=js&"
import style0 from "./GlassesTintsSelect.vue?vue&type=style&index=0&id=36d7bb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7bb1a",
  null
  
)

export default component.exports